module.exports = __webpack_public_path__ + "img/pilsum.4df23a7f.jpg";